import type { ResultArtifact } from '../../shared/conversationResultManifest';
import { isArtifactDownloadUrl } from './deliverableArtifacts';

/** 仅下载清单中的授权引用；账号切换与取消后不返回字节给旧页面，不降级为任意路径请求。 */
export async function readResultArtifact(artifact: ResultArtifact, signal: AbortSignal): Promise<Blob> {
  if (!isArtifactDownloadUrl(artifact.downloadUrl) || ['invalid', 'unavailable'].includes(artifact.state)) throw new Error('文件不可下载');
  const token = localStorage.getItem('boclaw_token'), userId = localStorage.getItem('boclaw_user_id');
  if (!token || !userId) throw new Error('请先登录');
  const response = await fetch(artifact.downloadUrl, { headers: { Authorization: `Bearer ${token}`, 'X-Boclaw-User-Id': userId }, signal });
  if (!response.ok) throw new Error('下载失败，请刷新检查结果后重试');
  const blob = await response.blob();
  signal.throwIfAborted();
  if (token !== localStorage.getItem('boclaw_token') || userId !== localStorage.getItem('boclaw_user_id')) throw new Error('账号已切换');
  if (!blob.size) throw new Error('文件为空');
  return blob;
}
